export const environment = {
	production: true,
	completeURL: 'https://apps-dev.simplelayers.com/',
	deployURL: 'https://apps-dev.simplelayers.com/',
	baseHref: 'https://apps-dev.simplelayers.com/',
	wapiURL: 'https://app-svc-dev.simplelayers.com/',
	mqGuid: 'me5vHyryLxRoPgkHskADP8AcixthCA0n',
	local: true,
	mapbox: {
		accessToken: 'pk.eyJ1Ijoic2ltcGxlbGF5ZXJzLWRldiIsImEiOiJjancyemhwdHMwNTl2NGJsOTc5NWE0OXF1In0.80Us-CdXyFJ6Qhgb3a--HQ'
	},
	envName: 'dev'
};
import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
